module.exports = __webpack_public_path__ + "static/img/1_8_2.9314e657.jpg";